module.exports = __webpack_public_path__ + "img/achievement_7.bbf71e0c.png";